import { UomCategoryListPage } from '@/features/uom-category/pages/UomCategoryListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/uom-category/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["uom_category.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: UomCategoryListPage,
})
